module.exports = __webpack_public_path__ + "static/img/registration-box.b2abb21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/registration-box.jpg
// module id = flNv
// module chunks = 0